import { forwardRef } from 'react';

import type { CardProps as MantineCardProps } from '@mantine/core';
import { Card as MantineCard, createPolymorphicComponent } from '@mantine/core';

import classes from './Card.module.css';

interface CardProps extends MantineCardProps {
  active?: boolean;
  mod?: Record<string, any>;
}

const _Card = forwardRef<HTMLDivElement, CardProps & { component: any }>(
  ({ children, active = false, mod, ...props }, ref) => {
    return (
      <MantineCard
        ref={ref}
        mod={{
          active,
          ...mod,
        }}
        {...props}
      >
        {children}
      </MantineCard>
    );
  }
) as any;

_Card.displayName = 'Card';
_Card.Section = MantineCard.Section;

const CardDefaults = MantineCard.extend({
  defaultProps: {
    radius: 'md',
  },
  classNames: {
    root: classes.root,
    section: classes.section,
  },
});

const Card = createPolymorphicComponent<'div', CardProps, { Section: typeof MantineCard.Section }>(
  _Card
);

export { Card, CardDefaults };
export type { CardProps };
